/**
 * ChatPurchaseFlow
 *
 * Small functional component that bridges the class-based CreatedChat
 * with the hook-based PurchaseFlowWrapper.
 *
 * Renders a PurchaseFlowWrapper in 'additionalFunds' modal mode
 * for the paymentRequiredOnContinue state.
 */

import React from 'react';
import { analyticsService } from '@common/analytics';
import { usePurchaseFlowRenderProps } from '@common/config/purchaseFlowRenderHelpers';
import PurchaseFlowWrapper from '../purchase_flow/containers/PurchaseFlowWrapper';
import classes from './classes.module.scss';

interface ChatPurchaseFlowProps {
  chatType: string;
  purchaseOnBack: () => void;
  purchaseSuccess: () => void;
}

const ChatPurchaseFlow: React.FC<ChatPurchaseFlowProps> = ({
  chatType,
  purchaseOnBack,
  purchaseSuccess
}) => {
  const { renderIcon, renderText } = usePurchaseFlowRenderProps();

  return (
    <PurchaseFlowWrapper
      mode="additionalFunds"
      onComplete={ purchaseSuccess }
      onCancel={ purchaseOnBack }
      onAnalyticsEvent={ (...args) => analyticsService.trackEvent(...args) }
      renderIcon={ renderIcon }
      renderText={ renderText }
      inModal
      popoverClassName="created-chat-purchase-details-container"
      popoverContentClassName={ classes.purchasesModalContent }
      chatType={ chatType }
      isContinue
      backArrowAction={ purchaseOnBack }
    />
  );
};

export default ChatPurchaseFlow;
